// Catches a crash in any screen after the first draw (Step 29). The app
// shows a plain "Something went wrong" with "Try again" (a reload) instead
// of a blank page, and logs the crash without its message.
import { Component, type ErrorInfo, type ReactNode } from 'react';
import type { ClientLog } from './client-log';

interface Props {
  children: ReactNode;
  reload: () => void;
  log: ClientLog;
}

export class AppErrorBoundary extends Component<Props, { hasCrashed: boolean }> {
  override state = { hasCrashed: false };

  static getDerivedStateFromError(): { hasCrashed: boolean } {
    return { hasCrashed: true };
  }

  override componentDidCatch(error: Error, _info: ErrorInfo): void {
    this.props.log('APP_CRASHED', error);
  }

  override render(): ReactNode {
    if (!this.state.hasCrashed) return this.props.children;
    return (
      <main className="shell-main">
        <p role="alert" data-testid="app-crash-error">
          Something went wrong. Please try again.
        </p>
        <button type="button" data-testid="app-crash-retry" onClick={this.props.reload}>
          Try again
        </button>
      </main>
    );
  }
}
